import { SPACES } from './board/spaces';
import { TILES } from './board/tiles';
import { CARDS } from './cards/cards';
import { CHARACTERS } from './player/characters';
import * as i0 from "@angular/core";
export var TurnStepType;
(function (TurnStepType) {
    TurnStepType[TurnStepType["drawTile"] = 0] = "drawTile";
    TurnStepType[TurnStepType["placeTile"] = 1] = "placeTile";
    TurnStepType[TurnStepType["move"] = 2] = "move";
    TurnStepType[TurnStepType["drawCard"] = 3] = "drawCard";
    TurnStepType[TurnStepType["preCombat"] = 4] = "preCombat";
    TurnStepType[TurnStepType["postCombat"] = 5] = "postCombat";
    TurnStepType[TurnStepType["xpEnd"] = 6] = "xpEnd";
})(TurnStepType || (TurnStepType = {}));
var GameService = /** @class */ (function () {
    // public flags = {
    // 	midTurn: false // rotating through characters during a turn instead of between turns, e.g. with an event
    // };
    function GameService() {
        this._numPlayers = 4;
        this._currPlayer = 0;
        this._turnStep = TurnStepType.drawTile;
        this._round = -1; // should start at -1: draw Starter cards, draw and place initial tiles, then game begins with Round 1
        this._midTurn = false;
    }
    Object.defineProperty(GameService.prototype, "numPlayers", {
        get: function () {
            return this._numPlayers;
        },
        set: function (value) {
            this._numPlayers = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GameService.prototype, "currPlayer", {
        get: function () {
            return this._currPlayer;
        },
        set: function (value) {
            if (value >= this.numPlayers) {
                if (!this.midTurn)
                    this.round++;
                value = 0;
            }
            this._currPlayer = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GameService.prototype, "turnStep", {
        get: function () {
            return this._turnStep;
        },
        set: function (value) {
            this._turnStep = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GameService.prototype, "round", {
        get: function () {
            return this._round;
        },
        set: function (value) {
            this._round = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GameService.prototype, "currentTile", {
        get: function () {
            return this._currentTile;
        },
        set: function (value) {
            this._currentTile = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GameService.prototype, "currentCard", {
        get: function () {
            return this._currentCard;
        },
        set: function (value) {
            this._currentCard = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GameService.prototype, "midTurn", {
        get: function () {
            return this._midTurn;
        },
        set: function (value) {
            this._midTurn = value;
        },
        enumerable: true,
        configurable: true
    });
    GameService.prototype.getBoard = function () {
        return SPACES;
    };
    GameService.prototype.getTiles = function () {
        return TILES;
    };
    GameService.prototype.getCards = function () {
        return CARDS;
    };
    GameService.prototype.getCharacters = function () {
        return CHARACTERS;
    };
    GameService.ngInjectableDef = i0.defineInjectable({ factory: function GameService_Factory() { return new GameService(); }, token: GameService, providedIn: "root" });
    return GameService;
}());
export { GameService };
